module.exports = __webpack_public_path__ + "assets/img/m_bdt_img1.4f42c881.png";